import React from "react";

const AddUsers = () => {
  return <div>add users</div>;
};

export default AddUsers;
